<template>
  <div>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered loading"
    ></v-progress-circular>
    <div class="report-crm" :class="{ 'blur--content': isLoading }">
      <h1 class="text-center">Customer Metrics</h1>
      <FilterMetric :filtered-data="filteredData" />
      <div class="button-group pt-7">
        <button
          class="btn btn-outline-dark"
          @click="
            () =>
              $router.push({
                name: 'CustomerMetrics',
              })
          "
        >
          Back
        </button>
        <button
          class="btn btn-outline-primary"
          :disabled="listRetentionData.length <= 0"
          @click="exportExcel"
          v-if="listRetentionData.length > 0"
        >
          Export to excel
        </button>
      </div>
      <MetricTable
        v-if="listRetentionData.length > 0"
        :fields="fields"
        :list-data="listRetentionData"
        :is-retention-metrics="true"
      />
      <div v-else-if="message">
        <h1 class="text-center">{{ message }}</h1>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h5 class="p-5 failureMessage">{{ failureMessage }}</h5>
        <div class="text-center">
          <button class="btn-back" @click="showDialog = false">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import fields from "@/json/reports/fields_crm.json";
import ReportService from "services/api/report.service";
import MetricTable from "@/views/Reports/MetricsUtils/MetricTable.vue";
import createWorkbook from "@/views/Reports/createWorkbook";
import FilterMetric from "@/views/Reports/MetricsUtils/FilterMetric.vue";

export default {
  components: { FilterMetric, MetricTable },
  data() {
    return {
      fileName: `customer_metrics_${moment().format("YYYYMMDDHHmmss")}`,
      listRetentionData: [],
      fields: fields,
      filteredData: {
        brand: null,
        date: null,
        isIncludeVVIP: false,
        channel: null,
        sources: null,
      },
      isLoading: false,
      message: null,
      failureMessage: null,
      showDialog: false,
    };
  },
  mounted() {
    this.getCustomerMetricsResult();
  },
  methods: {
    async getCustomerMetricsResult() {
      this.isLoading = true;
      const param = {
        process: this.$route.query.processId,
      };
      await ReportService.getRetentionMetrics(param)
        .then((res) => {
          const data = res.data;
          const requestData = data.request;
          this.filteredData = {
            brand: requestData.brandCode,
            date: requestData.date,
            isIncludeVVIP: requestData.isIncludeVVIP,
            channel: requestData.channel,
            sources: requestData.sources,
          };
          this.listRetentionData = data.crmMetrics;
          this.message = data.message;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          const errRes = err.response;
          if (errRes.status !== 400) {
            this.isLoading = false;
            this.failureMessage =
              errRes.data?.message ||
              "An error occurred, please try again later!";
            this.showDialog = true;
          }
        });
    },
    exportExcel() {
      createWorkbook.createExcel(
        this.listRetentionData,
        this.fields,
        this.fileName
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.export-btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #212529;
  background-color: transparent;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
}
.export-btn:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

.button-group {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.blur--content {
  filter: blur(2px);
  pointer-events: none;
}

.loading {
  z-index: 10;
}
</style>
